export function redirectTo(url: string): void {
  window.location.assign(url)
}
